import { GoogleMapComponent } from './google-map.component';

export default angular
  .module('sfMobile.components.google-map', ['sfMobile.services.google-map'])
  .component('sfGoogleMap', GoogleMapComponent).name;
